<template>
    <b-form-checkbox
    v-model="option.active"
    button button-variant="white"
    class="mb-5 w-100 optionCheckbox"
    :class="{ 'checked' : option.active, 'unchecked' : !option.active }"
    @change="checkboxChange"
    >
        <b-row class="w-100 ml-0">
            <b-col cols="auto" class="d-none d-md-flex">
                <img :src="option.image.src" :alt="option.image.alt" width="50" height="auto" />
            </b-col>

            <b-col class="p-3">
                <h2 class="h4">{{ option.text }}</h2>
                <div class="d-flex align-items-center">
                    <p class="mr-2">{{ option.description }}</p>

                    <b-button v-if="option.tooltip != null" :id="'tooltip-'+index" type="button" size="sm" pill class="mb-3">?</b-button>
                    <b-tooltip :target="'tooltip-'+index" triggers="hover" variant="primary">
                        <p v-html="option.tooltip" />
                    </b-tooltip>
                </div>
            </b-col>

            <b-col cols="5" md="3" class="bg-primary p-3 text-white">
                <p class="h4 font-weight-bold" v-if="option.freeTime == 0 && option.price != 0 && option.recurrence">{{ option.price }}{{ services.currency }} {{ services.tva }} / {{ option.recurence }}</p>
                <p class="h4 font-weight-bold" v-else-if="option.freeTime == 0 && option.price != 0 && !option.recurrence">{{ option.price }}{{ services.currency }} {{ services.tva }}</p>
                <p class="h4 font-weight-bold" v-else-if="option.price == 0 && !option.quote">Gratuit !</p>
                <p class="h4 font-weight-bold" v-else-if="option.price == 0 && option.quote">Devis</p>
                <p class="h4 font-weight-bold" v-else-if="option.freeTime > 1">{{ option.freeTime }} mois offerts !</p>
                <p class="h4 font-weight-bold" v-else>{{ option.freeTime }} mois offert !</p>
                <p class="h5" v-if="option.freeTime != 0 && !option.recurence">puis {{ option.price }}{{ services.currency }} {{ services.tva }} / {{ option.recurrence }}</p>
                <p class="h5" v-else-if="option.freeTime != 0 && option.recurence">puis {{ option.price }}{{ services.currency }} {{ services.tva }}</p>
                <p v-if="!option.engagement" class="font-italic">Sans engagement</p>

                <div class="d-flex justify-content-end">
                    <img src="../assets/images/icons/tick/white-checked-tick.svg" alt="Case cochée" width="40" height="40" id="checked-tick" class="tick" />
                    <img src="../assets/images/icons/tick/white-unchecked-tick.svg" alt="Case non cochée" width="40" height="40" id="unchecked-tick" class="tick" />
                </div>
            </b-col>
        </b-row>
    </b-form-checkbox>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            index: {
                type: Number
            },
            option: {
                type: Object
            },
        },
        methods: {
            checkboxChange() {
                this.$emit('checkboxChange', this.index);
            }
        },
        computed: {
            ...mapState(['services'])
        }
    }
</script>

<style lang="scss">
    .optionCheckbox label
    {
        padding: 0;
        width: 100%;
        border: 3px solid black;

        &:hover
        {
            border: 3px solid #ad233f;
            background-color: rgb(250, 250, 250);
        }
    }

    .checked label
    {
        border-color: #ad233f;
        background-color: rgb(250, 250, 250);

        #checked-tick
        {
            display: block;
        }
    }

    .unchecked label
    {
        #unchecked-tick
        {
            display: block;
        }
    }

    .tick
    {
        display: none;
    }
</style>
